import { Switch } from 'react-router-dom'
import { ProtectedRoute } from 'components/ProtectedRoute'
import { CIMSPage, Permission } from '@cims-online/shared'
import Types from './components/Types'
import Actions from './components/Actions'
import Organizations from './components/Organizations'
import DesignSubmittalLog from './components/DesignSubmittalLog'
import { Disciplines } from './components/Disciplines'
import DSQuickLinks from './components/DSQuickLinks'
import Notifications from './components/Notifications'

const DesignSubmittals = () => {
  return (
    <Switch>
      <ProtectedRoute
        path={[CIMSPage.DSLog.recordPath, CIMSPage.DSLog.projectPath]}
        permissions={Permission.ViewDesignSubmittal}
      >
        <DesignSubmittalLog />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.DSNotifications.projectPath}
        permissions={Permission.ViewDSNotification}
      >
        <Notifications />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.DSDisciplines.projectPath}
        permissions={Permission.ViewDesignSubmittalDiscipline}
      >
        <Disciplines />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.DSQuickLinks.projectPath}
        permissions={Permission.ViewDesignSubmittalQuickLink}
      >
        <DSQuickLinks />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.DSTypes.projectPath}
        permissions={Permission.ViewDesignSubmittalType}
      >
        <Types />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.DSOrganizations.projectPath}
        permissions={Permission.ViewDesignSubmittalOrganization}
      >
        <Organizations />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.DSActions.projectPath}
        permissions={Permission.ViewDesignSubmittalAction}
      >
        <Actions />
      </ProtectedRoute>
    </Switch>
  )
}

export default DesignSubmittals
